import { defineMessages } from 'react-intl'

const scope = `procurify.components.PunchOutSupplierIcon`

export default defineMessages({
  imageAltText: {
    id: `${scope}.imageAltText`,
    defaultMessage: '{name} Icon',
  },
})
